import { AdminConfig } from "structure/admin"
import { Feature, t } from "util/stdtypes";

export const AdminModLinkFeature : Feature<AdminConfig, {}> = {
    key: 'admin_link_mod',
    name: 'Legacy Moderation Link',
    providesConfig: {
        quickLinks: [{label: t('Legacy Moderation Dashboard'), structureKey: 'moderationdash'}]
    }
}
 
export const NewModLinkFeature : Feature<AdminConfig, {}> = {
    key: 'admin_new_link_mod',
    name: 'New Moderation Link',
    providesConfig: {
        quickLinks: [{label: t('New Moderation Dashboard'), structureKey: 'moddashboard'}]
    }
}
 
export const EditorialDashFeature : Feature<AdminConfig, {}> = {
    key: 'admin_editorial_dash',
    name: 'Editorial Dashboard',
    providesConfig: {
        quickLinks: [{label: t('Editorial Dashboard'), structureKey: 'editorialdash'}]
    }
}

export const DeveloperToolsFeature : Feature<AdminConfig, {}> = {
    key: 'admin_developer_tools',
    name: 'Developer Tools',
    dev: true,
    providesConfig: {
        quickLinks: [{label: t('Developer Tools'), structureKey: 'developer-tools'}]
    }
}
